import { ReactNode } from "react";

type Props = {
  title: string;
  description: string;
  weight: number;
  src: string;
  children?: ReactNode;
};

export default function EstateFridgeCard({ title, description, weight, src, children }: Props) {
  return (
    <div
      className="flex flex-col p-5 bg-dark-800 rounded-[0.75rem]"
      style={{ width: "calc(33.3333% - 0.25rem)" }}
    >
      <div className="relative flex flex-wrap w-full h-[9.375rem] bg-[url(/svg/dots.svg)] bg-center bg-no-repeat">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-13 rounded-[50%] bg-accent-solid"
          style={{ filter: "blur(4px)", WebkitFilter: "blur(50px)" }}
        />
        <div
          className="absolute z-1 top-1/2 left-1/2 size-full -translate-x-1/2 -translate-y-1/2"
          style={{
            backgroundImage: `url(${src})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="relative z-2 flex justify-end items-center w-full mb-auto">
          <p className="text-10 font-extrabold uppercase">
            <span className="text-11 font-bold text-accent-solid">{weight}</span> kg
          </p>
        </div>
      </div>
      <p className="mb-1 text-16 font-medium">{title}</p>
      <p
        className="mb-4 h-9 text-15 font-medium opacity-60 overflow-hidden"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
        }}
      >
        {description}
      </p>
      {children}
    </div>
  );
}
